import { Box } from "@chakra-ui/react";
import sanitizeHtml from "sanitize-html";

import { allowedTags } from "./allowedTags";
import { allowedAttributes } from "./allowedAttributes";
import {ChakraProps} from "@chakra-ui/system/dist/types/system.types";

interface IProps extends ChakraProps {
  html: string;
}

const DangerousInnerHtml = ({ html, ...props }: IProps) => {
  const sanitizedHtml = sanitizeHtml(html, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttributes,
  });
  return (
      <Box
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          {...props}
      />)
};

export { DangerousInnerHtml };
